/**
 * Creates a SEO-friendly slug for a job posting.
 * Format: {title}-{facility}-{city}-{state}--{id}
 * The ID is embedded after double-dash for reliable lookup.
 */
export function createJobSlug(job) {
  const slugify = (str) =>
    (str || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  const parts = [
    job.title,
    job.facility_name,
    job.city || '',
    job.state || '',
  ]
    .filter(Boolean)
    .map(slugify)
    .filter(Boolean)
    .join('-');

  return `${parts}--${job.id}`;
}

/**
 * Extracts the job ID from a slug (after the last '--')
 */
export function getJobIdFromSlug(slug) {
  if (!slug) return null;
  // If it's already a plain ID (legacy ?id= param), return as-is
  if (!slug.includes('--')) return slug;
  const parts = slug.split('--');
  return parts[parts.length - 1];
}

/**
 * Returns the URL for a job detail page using its slug
 */
export function jobDetailUrl(job) {
  return `JobDetails?slug=${createJobSlug(job)}`;
}